export const FETCH_NOVELS = "FETCH_NOVELS";
export const fetchNovelsAction = (novels:any) => {
    return {
        type: "FETCH_NOVELS",
        payload: novels
    }
};